module.exports = __webpack_public_path__ + "static/media/interview14.26019a7a.jpg";